import { PayPalNVP } from 'src/pages/paypalnvp/paypal-nvp';
import { EXTERNAL_URLS, CUSTOMER_SERVICE_PHONE, CUSTOMER_SERVICE_HOURS_MOBILE, CUSTOMER_SERVICE_HOURS_DESKTOP } from 'src/constants/param-constants';

import { AfterViewInit, Component, HostListener, NgZone, OnDestroy, OnInit } from '@angular/core';
import { PlatformLocation, CurrencyPipe } from '@angular/common'
import { DomSanitizer } from '@angular/platform-browser';
import { NgForm, FormControl } from '@angular/forms';
import { Storage } from '@ionic/storage-angular';
import { Router } from '@angular/router';


import { ToastController } from 'src/app/components/ionic-replacements/ToastController';
import { NavControllerExt } from 'src/app/extensions/nav-controller-extension';
import { OrderProviderExtender } from '../../../providers/order/order-extender';
import { TouchcrApiOrderformProvider } from '../../../providers/touchcr-api-orderform/touchcr-api-orderform';
import { CartProvider } from '../../../providers/cart/cart';
import { TouchcrApiRemoteServicesProvider } from 'src/app/providers/touchcr-api-remoteservices';
import { TouchcrApiLeadProvider } from '../../../providers/touchcr-api-lead/touchcr-api-lead';
import { TouchcrApiCouponProvider } from '../../../providers/touchcr-api-coupon/touchcr-api-coupon';
import { OrderDetailsProvider } from '../../../providers/order-details/order-details';
import { TouchcrApiShippingProvider } from '../../../providers/TouchcrApiShippingProvider';
import { CalculateProvider } from '../../../providers/calculate/calculate';
import { UrlsProvider } from 'src/app/providers/urls';
import { OrderProvider } from 'src/app/providers/order/order';
import { GeneralProvider } from 'src/app/providers/general';
import { LoggingProvider } from 'src/app/providers/logging';
import { SpinnerProvider } from '../../../providers/spinner/spinner';
import { TouchcrApiGeneralExtenderProvider } from '../../../providers/touchcr-api-general/touchcr-api-general-extender';
import { TouchcrApiOrderExtenderProvider } from '../../../providers/touchcr-api-order/touchcr-api-order-extender';
import { EventStreamerProvider } from 'src/app/providers/event-stream';
import { PaypalPaymentExtenderProvider } from '../../../providers/paypal/paypal-extender';
import { StateProvider } from 'src/app/providers/state';
import { FunnelSettingsProvider } from 'src/app/providers/funnel-settings';
import { Country } from '../../../models/country';
import { CHECKOUT_LABEL, PAYMENT_LABEL, SHIPPING_LABEL } from 'src/constants/constants';
import { DynamicCurrencyPipe } from 'src/app/shared/pipes/dynamic-currency.pipe';
import { CheckoutCommon } from '../../_brand-pages-base/base-controllers/checkout/checkout-common';

const ROUTE = (window as any)['process_env'].ROUTE;
const API_URL = (window as any)['process_env'].API_URL;
@Component({
  selector: 'checkout-common-v3',
  templateUrl: './checkout-common-v3.html',
  styleUrls: ['./checkout-common-v3.scss']
})
export class CheckoutCommonV3 extends CheckoutCommon {
  private readonly plugNPlayProductSku: string = 'DEPLUGNPLAY';
  private readonly plugNPlayGroupSku: string = 'DEPLUGNPLAY-COURSE';
  private readonly plugNPlayOfferPriceFallback: number = 37;
  /**
   * `DE Bump Plug N Play Scripts` Ids per Salesforce org, used only while the API cannot serve the
   * offer itself.
   *
   * GET orderforms/bumpoffers/<route> answers [] for every Driven Entrepreneur page because that
   * endpoint matches an OrderForm on its Route field, and every DE order form has Route = null
   * (Gundry's carry values such as 'Gundry_SecureCart'). Posting the order form Id directly in
   * `bumpoffers` lets Salesforce price the order at 97 + 37, so the posted total matches the line
   * items and the bump lands as a real order item.
   *
   * Once Route is populated in Salesforce, `currentFunnel.route` resolves, the API returns the offer,
   * and this map is never consulted - delete it then.
   *
   * Salesforce Ids are org-specific: the same record has different Ids in the sandbox and in
   * production, so the org is chosen by API host. A blank entry disables the fallback for that org -
   * the offer card stays hidden and checkout runs without the bump, which is the safe failure. Never
   * put a sandbox Id on the production side; it cannot resolve there and every submit would be
   * rejected. DEV-55220
   */
  private readonly plugNPlayFallbackIdsByOrg: { [org: string]: { orderFormId: string; productId: string } } = {
    uat: { orderFormId: 'a0CQL00004l0xEK2AY', productId: '01tQL00000SFttkYAD' },
    prod: { orderFormId: '', productId: '' },
  };
  private readonly plugNPlayMatchPattern: RegExp = /plug\s*[-']?\s*n\s*[-']?\s*play|DEPLUGNPLAY/i;
  private readonly sellLikeASharkRetailPriceFallback: number = 497;
  private readonly sellLikeASharkOfferPriceFallback: number = 97;
  override iconPaypal: string = EXTERNAL_URLS.PAYPAL_BUTTON;
  public override twoNameShipping: boolean = true;
  public customerServicePhone: string = CUSTOMER_SERVICE_PHONE;
  public customerServiceHours_Mobile: string = CUSTOMER_SERVICE_HOURS_MOBILE;
  public customerServiceHours_Desktop: string = CUSTOMER_SERVICE_HOURS_DESKTOP;
  public isPlugNPlayOfferSelected: boolean = false;
  public showStickyClaimButton: boolean = false;
  public heroBackgroundImage: string = 'https://cdn.drivenentrepreneur.com/images/hero_fade.jpg';
  public heroMobileBackgroundImage: string = 'https://cdn.drivenentrepreneur.com/images/hero_m.webp';
  public featureImage: string = 'https://cdn.drivenentrepreneur.com/images/checkout-55220-feature.png';
  public supportLink: string = 'https://drivenentrepreneur.com/contact';
  public supportFaqs: Array<{ question: string; answer: string; isOpen: boolean }> = [
    {
      question: 'Who is Sell Like A Shark™ for?',
      answer: 'Sell Like A Shark is designed for founders, business owners, and sales professionals who want a proven system to attract more customers, close more deals, and grow revenue faster.',
      isOpen: false
    },
    {
      question: 'Will this work for my business?',
      answer: 'Yes. The training focuses on timeless sales principles, messaging, and follow-up frameworks that can be adapted across both B2B and B2C businesses.',
      isOpen: false
    },
    {
      question: 'How is the training delivered?',
      answer: 'You will receive digital access after checkout so you can start working through the training right away from any supported device.',
      isOpen: false
    },
    {
      question: 'How do I access the content?',
      answer: 'After your order is processed, you will receive access details by email with instructions for logging in and viewing the program materials.',
      isOpen: false
    },
    {
      question: 'How long can I access the training?',
      answer: 'You will have ongoing access to the training materials included with your purchase so you can revisit the content whenever you need it.',
      isOpen: false
    },
    {
      question: 'Is there a money-back guarantee?',
      answer: 'Yes. You are covered by a 30-day money back guarantee. If you decide the program is not the right fit within the first 30 days, contact support for a refund.',
      isOpen: false
    }
  ];
  constructor(
    public override navCtrl: NavControllerExt,
    public override sanitizer: DomSanitizer,
    public override tcrApiOrderform: TouchcrApiOrderformProvider,
    public override cart: CartProvider,
    public override tcrApi: TouchcrApiGeneralExtenderProvider,
    public override tcrApiOrder: TouchcrApiOrderExtenderProvider,
    public override tcrApiRemoteServices: TouchcrApiRemoteServicesProvider,
    public override toastCtrl: ToastController,
    public override eventStreamer: EventStreamerProvider,
    public override tcrApiLead: TouchcrApiLeadProvider,
    public override tcrApiCoupon: TouchcrApiCouponProvider,
    public override orderDetails: OrderDetailsProvider,
    public override paypalPayment: PaypalPaymentExtenderProvider,
    public override ngZone: NgZone,
    public override shippingProvider: TouchcrApiShippingProvider,
    public override calculateHelper: CalculateProvider,
    public override urlsHelper: UrlsProvider,
    public override orderHelper: OrderProvider,
    public override orderHelperExtender: OrderProviderExtender,
    public override stateProvider: StateProvider,
    public override general: GeneralProvider,
    public override funnelProvider: FunnelSettingsProvider,
    public override spinner: SpinnerProvider,
    public override location: PlatformLocation,
    public override loggingProvider: LoggingProvider,
    public override currencyPipe: CurrencyPipe,
    public override router: Router,
    public override dynamicCurrencyPipe: DynamicCurrencyPipe,
    public override storage?: Storage
  ) {
    super(
      navCtrl,
      sanitizer,
      tcrApiOrderform,
      cart,
      tcrApi,
      tcrApiOrder,
      tcrApiRemoteServices,
      toastCtrl,
      eventStreamer,
      tcrApiLead,
      tcrApiCoupon,
      orderDetails,
      paypalPayment,
      ngZone,
      shippingProvider,
      calculateHelper,
      urlsHelper,
      orderHelper,
      orderHelperExtender,
      stateProvider,
      general,
      funnelProvider,
      spinner,
      location,
      loggingProvider,
      currencyPipe,
      router,
      dynamicCurrencyPipe,
      storage
    );
  }

  //Use this method to set up initial values for template variables
  override populatePageData() {
    let body = document.getElementsByTagName('body')[0];
    body.setAttribute('data-qa', 'checkout-page');
    this.brandLogo = '/assets/img/drivenEntrepreneur-logo.png';
  }

  override async populateData() {
    await super.populateData();

    if (!this.bumpOffers?.length) {
      try {
        this.bumpOffers = await this.getBumpOffersForCurrentFunnel();
        this.logPlugNPlayPayloadState('populateData:getBumpOffersForCurrentFunnel');
      } catch (e) {
        console.log(e);
      }
    }

    await this.restorePlugNPlaySelection();
  }

  get sellLikeASharkRetailPrice(): number {
    return this.currentFunnel?.standardPrice ?? this.sellLikeASharkRetailPriceFallback;
  }

  get sellLikeASharkOfferPrice(): number {
    return this.currentFunnel?.offerPrice ?? this.sellLikeASharkOfferPriceFallback;
  }

  get plugNPlayOfferPrice(): number {
    return this.getPlugNPlayBumpOffer()?.offerPrice ?? this.plugNPlayOfferPriceFallback;
  }

  /**
   * Salesforce returns the bump offers configured on this funnel page, so anything it returns here is
   * the offer to sell. Match on the fields that actually carry text: `sfid`, `producttobesold` and
   * `touchcrbase__producttobesold__c` hold Salesforce Ids (a0C.../01t...), never SKUs, so comparing
   * them to 'DEPLUGNPLAY' could never match and the bump never reached the payload. DEV-55220
   */
  private getPlugNPlayBumpOffer(): any {
    const bumpOffers = this.bumpOffers || [];
    if (!bumpOffers.length) {
      return undefined;
    }

    return bumpOffers.find((offer: any) => this.matchesPlugNPlay(offer)) ?? bumpOffers[0];
  }

  private matchesPlugNPlay(offer: any): boolean {
    return [
      offer?.sku,
      offer?.productSku,
      offer?.name,
      offer?.product?.sku,
      offer?.product?.productcode,
      offer?.product?.name,
    ].some((value: any) => typeof value === 'string' && this.plugNPlayMatchPattern.test(value));
  }

  private async getBumpOffersForCurrentFunnel() {
    const funnelSettingsBumpOffers = await this.funnelProvider.getBumpOffers();
    if (funnelSettingsBumpOffers?.length) {
      return funnelSettingsBumpOffers;
    }

    const currentUrl = this.funnelProvider.getCurrentUrl();
    const route = this.currentFunnel?.route || this.funnel?.route || ROUTE || currentUrl;
    if (route) {
      console.log('[CheckoutCommonV3] Loading bump offers by route fallback', {
        route,
        currentUrl,
        routeFromProcessEnv: ROUTE,
        currentFunnelRoute: this.currentFunnel?.route,
        funnelRoute: this.funnel?.route,
      });
      const apiBumpOffers = await this.tcrApiOrderform.getBumpOffers(route).toPromise();
      if (apiBumpOffers?.length) {
        return apiBumpOffers;
      }

      console.log('[CheckoutCommonV3] API returned no bump offers for this page, using the fallback order form', {
        route,
        fallbackOrderFormId: this.plugNPlayFallbackIds.orderFormId,
      });
      const pageOffer = this.buildBumpOfferFromFunnelPage();
      if (pageOffer) {
        return [pageOffer];
      }

      const fallbackOffer = this.buildFallbackPlugNPlayBumpOffer();
      return fallbackOffer ? [fallbackOffer] : [];
    }

    console.log('[CheckoutCommonV3] Skipping bump offer API lookup because no route was resolved', {
      routeFromProcessEnv: ROUTE,
      currentFunnelRoute: this.currentFunnel?.route,
      funnelRoute: this.funnel?.route,
      currentUrl,
    });

    const pageOffer = this.buildBumpOfferFromFunnelPage();
    if (pageOffer) {
      return [pageOffer];
    }

    const fallbackOffer = this.buildFallbackPlugNPlayBumpOffer();
    return fallbackOffer ? [fallbackOffer] : [];
  }

  /**
   * Reads the Bump Offer configured on this funnel page. Salesforce delivers it in funnel_confs right
   * next to the page's Upsell/Downsell and in the same shape (an order form Id, or an expanded
   * record), which means the Id always belongs to the org this app is pointed at - so this path needs
   * no hardcoded Ids and behaves identically in UAT and production.
   *
   * Returns null until someone populates Bump Offer on the funnel page in Salesforce; today it is
   * null on `IFP - Driven Entrepreneur - 1 Unit - $97` while steps 2-5 of the same funnel carry
   * Upsell/Downsell values. DEV-55220
   */
  private buildBumpOfferFromFunnelPage(): any {
    let configured: any = null;
    try {
      const mainFunnel: any = this.funnelProvider.getMainFunnelByCurrentUrl();
      const currentUrl = this.funnelProvider.getCurrentUrl();
      const page = (mainFunnel?.defaultFunnels || []).find((step: any) =>
        step?.url === currentUrl || (step?.variants || []).some((variant: any) => variant?.url === currentUrl)
      );
      configured = page?.bumpOffer ?? null;
    } catch (e) {
      console.log('[CheckoutCommonV3] Failed to read bumpOffer from the funnel page', e);
      return null;
    }

    if (!configured) {
      return null;
    }

    // Salesforce sends either the order form Id (how upsell/downsell arrive) or the expanded record.
    const orderFormId = typeof configured === 'string' ? configured : configured.sfid;
    if (!orderFormId) {
      return null;
    }

    const expanded = typeof configured === 'string' ? {} : configured;
    console.log('[CheckoutCommonV3] Using the bump offer configured on the funnel page', { orderFormId });

    return this.buildPlugNPlayBumpOffer(
      orderFormId,
      expanded.product?.sfid || expanded.producttobesold || '',
      expanded.offerPrice ?? this.plugNPlayOfferPriceFallback,
      expanded.name || 'DE Bump Plug N Play Scripts'
    );
  }

  /**
   * Minimum shape CalculateProvider and OrderProviderExtender need: `sfid` becomes the orderFormId in
   * the `bumpoffers` payload, `offerPrice` is folded into totalPrice, and the name lets
   * matchesPlugNPlay() find it. DEV-55220
   */
  private get plugNPlayFallbackIds(): { orderFormId: string; productId: string } {
    const isUat = (API_URL || '').indexOf('uat-') > -1;
    return this.plugNPlayFallbackIdsByOrg[isUat ? 'uat' : 'prod'];
  }

  private buildFallbackPlugNPlayBumpOffer(): any {
    const { orderFormId, productId } = this.plugNPlayFallbackIds;
    if (!orderFormId || !productId) {
      console.log('[CheckoutCommonV3] No fallback bump offer configured for this org, offer stays hidden', { API_URL });
      return null;
    }

    return this.buildPlugNPlayBumpOffer(orderFormId, productId, this.plugNPlayOfferPriceFallback, 'DE Bump Plug N Play Scripts');
  }

  private buildPlugNPlayBumpOffer(orderFormId: string, productId: string, offerPrice: number, name: string): any {
    return {
      sfid: orderFormId,
      name: name,
      offerPrice: offerPrice,
      standardPrice: offerPrice,
      shippingCost: 0,
      internationalShippingCost: 0,
      count: 1,
      isInCart: false,
      isActive: true,
      isPurchaseAvailable: true,
      isSubscriptionAvailable: false,
      isFreeFirstShipping: false,
      formType: 'Bump Offer',
      producttobesold: productId,
      touchcrbase__producttobesold__c: productId,
      orderFormProduct: [],
      // getProductsForShipping() dereferences product.sfid on every bump offer in the cart, so this
      // has to be a real product or calculate() throws and the page hangs on "Calculating taxes".
      product: {
        sfid: productId,
        name: "Driven Entrepreneur Shark Plug N' Play Sales Scripts",
        productTaxCode: 'DV021007',
        itemType: 'Digital Product',
        weight: 0,
        image: [],
        detailsInfo: [],
      },
    };
  }

  /**
   * The base implementation dereferences `product.sfid` on funnel and bump offer entries with no
   * guard. Anything unexpected in those lists throws inside calculate(), which never recovers and
   * leaves the spinner up forever. Shipping is not applicable to these digital products, so an empty
   * list is a safe answer. DEV-55220
   */
  override getProductsForShipping() {
    try {
      return super.getProductsForShipping();
    } catch (e) {
      console.log('[CheckoutCommonV3] getProductsForShipping failed, continuing with no shipping products', e);
      return [];
    }
  }

  private getOrderFormDebugInfo(orderForm: any) {
    if (!orderForm) {
      return null;
    }

    return {
      sfid: orderForm.sfid,
      name: orderForm.name,
      productSfid: orderForm.product?.sfid,
      productName: orderForm.product?.name,
      productToBeSold: orderForm.producttobesold,
      productToBeSoldId: orderForm.touchcrbase__producttobesold__c,
      offerPrice: orderForm.offerPrice,
      standardPrice: orderForm.standardPrice,
      isInCart: orderForm.isInCart,
      formType: orderForm.formType,
      type: orderForm.type,
    };
  }

  private logPlugNPlayPayloadState(context: string) {
    try {
      const plugNPlayBumpOffer = this.getPlugNPlayBumpOffer();

      console.log('[CheckoutCommonV3] Plug-N-Play payload state', {
        context,
        route: ROUTE,
        resolvedRoute: this.currentFunnel?.route || this.funnel?.route || ROUTE || this.funnelProvider.getCurrentUrl(),
        isPlugNPlayOfferSelected: this.isPlugNPlayOfferSelected,
        matchCriteria: {
          orderFormSfid: this.plugNPlayGroupSku,
          productSfid: this.plugNPlayProductSku,
          productToBeSold: this.plugNPlayProductSku,
        },
        matchedBumpOffer: this.getOrderFormDebugInfo(plugNPlayBumpOffer),
        currentFunnel: this.getOrderFormDebugInfo(this.currentFunnel),
        funnelOffersData: (this.funnelOffersData || []).map((offer: any) => this.getOrderFormDebugInfo(offer)),
        bumpOffers: (this.bumpOffers || []).map((offer: any) => this.getOrderFormDebugInfo(offer)),
        bumpOffersInCart: (this.bumpOffersInCart || []).map((offer: any) => this.getOrderFormDebugInfo(offer)),
        orderFormProduct: (this.orderFormProduct || []).map((product: any) => ({
          sfid: product.sfid,
          productSfid: product.product?.sfid,
          productName: product.product?.name,
          purchasePrice: product.purchasePrice,
          standardPrice: product.standardPrice,
          touchcrbaseOrderForm: product.touchcrbase__orderform__c,
        })),
        expectedPayloadLists: {
          funnels: (this.funnelOffersData || []).map((offer: any) => ({
            orderFormId: offer.sfid,
            count: 1,
          })),
          bumpoffers: (this.bumpOffersInCart || []).map((offer: any) => ({
            orderFormId: offer.sfid,
            count: 1,
          })),
        },
        totals: {
          totalPrice: this.totalPrice,
          funnelPrice: this.funnelPrice,
          totalTax: this.totalTax,
          totalTaxforBody: this.totalTaxforBody,
          plugNPlayOfferPrice: this.plugNPlayOfferPrice,
          orderSummaryTotal: this.getOrderSummaryTotal(),
        },
      });
    } catch (e) {
      console.log('[CheckoutCommonV3] Failed to log Plug-N-Play payload state', e);
    }
  }

  private syncPlugNPlayPayloadItems(context: string = 'syncPlugNPlayPayloadItems') {
    const plugNPlayBumpOffer = this.getPlugNPlayBumpOffer();
    if (plugNPlayBumpOffer) {
      plugNPlayBumpOffer.isInCart = this.isPlugNPlayOfferSelected;
    }

    this.bumpOffersInCart = plugNPlayBumpOffer && this.isPlugNPlayOfferSelected ? [plugNPlayBumpOffer] : [];
    this.orderFormProduct = [];
    this.logPlugNPlayPayloadState(context);
  }

  getTotalInstallments(): number {
    if (this.currentFunnel?.totalInstallments) {
      return this.currentFunnel.totalInstallments;
    }
    
    if (this.currentFunnel?.orderFormBrand?.defaultInstallmentCount) {
      return this.currentFunnel.orderFormBrand.defaultInstallmentCount;
    }
    
    return 0;
  }

  getInitialInstallmentAmount(): number {
    if (this.currentFunnel?.initialInstallmentAmount) {
      return this.currentFunnel.initialInstallmentAmount;
    }
    
    const totalInstallments = this.getTotalInstallments();
    if (this.currentFunnel?.offerPrice && totalInstallments > 0) {
      return this.currentFunnel.offerPrice / totalInstallments;
    }
    
    return 0;
  }

  /**
   * The bump can only be ordered when Salesforce returns a bump offer order form for this funnel.
   * Without one there is no orderFormId for the `bumpoffers` payload, so the offer must not be shown
   * or priced - the posted orderTotal would no longer match what the backend recalculates from the
   * line items and the order is rejected with "Price mismatch". DEV-55220
   */
  get isPlugNPlayOfferAvailable(): boolean {
    return !!this.getPlugNPlayBumpOffer();
  }

  private get selectedPlugNPlayPrice(): number {
    return this.isPlugNPlayOfferSelected && this.isPlugNPlayOfferAvailable ? this.plugNPlayOfferPrice : 0;
  }

  /**
   * Restores the bump selection when the component is re-instantiated, e.g. the PayPal NVP flow
   * returns to this page with ?paypalnvp&action=execute after a full reload. DEV-55220
   */
  private async restorePlugNPlaySelection() {
    if (!this.isPlugNPlayOfferAvailable) {
      this.isPlugNPlayOfferSelected = false;
      this.syncPlugNPlayPayloadItems('restorePlugNPlaySelection:offerUnavailable');
      return;
    }

    try {
      const storedBumpOffers = await this.cart.getBumpOffers();
      const plugNPlayBumpOffer = this.getPlugNPlayBumpOffer();
      const storedPlugNPlay = (storedBumpOffers || []).find((offer: any) => offer?.sfid === plugNPlayBumpOffer?.sfid);
      if (storedPlugNPlay?.isInCart) {
        this.isPlugNPlayOfferSelected = true;
      }
    } catch (e) {
      console.log('[CheckoutCommonV3] Failed to restore Plug-N-Play selection', e);
    }

    this.syncPlugNPlayPayloadItems('restorePlugNPlaySelection');
  }

  private persistPlugNPlaySelection() {
    try {
      this.cart.setBumpOffers(this.bumpOffers || []);
    } catch (e) {
      console.log('[CheckoutCommonV3] Failed to persist Plug-N-Play selection', e);
    }
  }

  getOrderSummaryTotal(): number {
    // Mirror the orderTotal that is actually posted (createBody sends this.totalPrice) so the summary
    // can never display a total the backend will reject. DEV-55220
    if (this.totalPrice > 0) {
      return this.totalPrice;
    }

    return this.sellLikeASharkOfferPrice + this.totalTax + this.selectedPlugNPlayPrice;
  }

  getInitialInstallmentSummaryTotal(): number {
    return this.getInitialInstallmentAmount() + this.totalTax + this.selectedPlugNPlayPrice;
  }

  onPlugNPlayOfferChange() {
    if (this.isPlugNPlayOfferSelected && !this.isPlugNPlayOfferAvailable) {
      this.isPlugNPlayOfferSelected = false;
    }

    this.syncPlugNPlayPayloadItems('onPlugNPlayOfferChange');
    this.persistPlugNPlaySelection();
    this.calculate(false);
  }

  override async calculate(getShipping: Boolean, getTax: Boolean = true, country: any = undefined) {
    // isInCart has to be set before super.calculate() runs so CalculateProvider.calculateBumpOffers()
    // folds the bump price into totalPrice. The price is never added on the client. DEV-55220
    this.syncPlugNPlayPayloadItems('calculate:beforeSuper');
    await super.calculate(getShipping, getTax, country);
    this.syncPlugNPlayPayloadItems('calculate:afterSuper');
  }

  override createFunnelProductBodyForCountry(funnel: any, funnelProducts: any, selectedProduct: any, shipToCountry: any) {
    this.orderFormProduct = [];
    return [];
  }

  onGetAccessNowClicked(accountForm: NgForm, paymentForm: NgForm, diffAddress: NgForm) {
    this.syncPlugNPlayPayloadItems('onGetAccessNowClicked');

    if (this.braintreeClientToken && (!this.enableCyberSource || this.braintreePayPalTokenizedPayment)) {
      return this.payWithBrainTree(accountForm, diffAddress);
    }

    if (this.isPayPalBillingAgreementApproved) {
      return this.submitPayPalOrder(accountForm);
    }

    if (this.buttonList[0].isPlaceOrder) {
      return this.onPayWithDifferentAddressClicked(accountForm, paymentForm, diffAddress);
    }

    return this.submitAmazonPay(accountForm);
  }

  override checkoutPayPal() {
    this.syncPlugNPlayPayloadItems('checkoutPayPal');
    return super.checkoutPayPal();
  }

  override submitPayPalOrder(accountForm: NgForm) {
    this.syncPlugNPlayPayloadItems('submitPayPalOrder');
    return super.submitPayPalOrder(accountForm);
  }

  override continuePayingWithBraintree() {
    this.syncPlugNPlayPayloadItems('continuePayingWithBraintree');
    return super.continuePayingWithBraintree();
  }

  toggleFaqItem(selectedFaq: { question: string; answer: string; isOpen: boolean }) {
    this.supportFaqs = this.supportFaqs.map((faq) => ({
      ...faq,
      isOpen: faq === selectedFaq ? !faq.isOpen : false
    }));
  }

  scrollToSubmitButtons() {
    const orderSummary = document.querySelector('.summaryCard');
    (orderSummary ?? document.getElementById('checkout-submit-buttons'))?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  @HostListener('window:scroll')
  onWindowScroll() {
    const recapSection = document.querySelector('.recap');
    if (!recapSection) {
      this.showStickyClaimButton = false;
      return;
    }

    const recapTop = recapSection.getBoundingClientRect().top;
    this.showStickyClaimButton = recapTop <= window.innerHeight;
  }

} 
